import type { Vec3 } from './view.js';

/**
 * Beside the skeleton's head, on its left. Tried twice lower down on a Quest 3
 * and hidden both times: by the feet behind the tray, by the hip behind the
 * lectern panel. The left because the skull's own name is on the right.
 */
export const SKELETON_LOCK_ANCHOR: Vec3 = [-0.3, 1.62, 0.05];

/** From this height up, what an AR lesson places is person-sized. */
export const PERSON_SIZED_METRES = 1.4;

export type Bounds = { readonly min: Vec3; readonly max: Vec3 };

/**
 * Where an AR lesson's padlock goes, in the lesson's own space.
 *
 * The skeleton's place was found on a headset and stays exactly where it
 * was for anything person-sized. A smaller set of shapes on a table (ADR-030)
 * would have had its padlock floating half a metre above it at head height;
 * it goes by the set's top-left corner instead, with the handles running on
 * to the left as they always do (handles.ts, Toolbar).
 */
export function lockAnchor(bounds: Bounds): Vec3 {
  if (bounds.max[1] >= PERSON_SIZED_METRES) return SKELETON_LOCK_ANCHOR;
  return [bounds.min[0] - 0.1, bounds.max[1], (bounds.min[2] + bounds.max[2]) / 2];
}
